import { action } from "satcheljs";

const defaultExport: () => {} = action("loadCommandBarActions");
export default defaultExport;
